import React, { useState, useEffect } from 'react';
import api from '../api';

const CATEGORIES = [
  { value: 'fruits_legumes', label: 'Fruits & Légumes', emoji: '&#129382;' },
  { value: 'viandes', label: 'Viandes & Poissons', emoji: '&#129385;' },
  { value: 'produits_laitiers', label: 'Produits laitiers', emoji: '&#129472;' },
  { value: 'epicerie', label: 'Épicerie', emoji: '&#127838;' },
  { value: 'surgeles', label: 'Surgelés', emoji: '&#129482;' },
  { value: 'boissons', label: 'Boissons', emoji: '&#129380;' },
  { value: 'hygiene', label: 'Hygiène & Maison', emoji: '&#129532;' },
  { value: 'autre', label: 'Autre', emoji: '&#128230;' },
];

export default function ShoppingPage() {
  const [items, setItems] = useState([]);
  const [newName, setNewName] = useState('');
  const [newCat, setNewCat] = useState('autre');
  const [newQty, setNewQty] = useState('');

  const load = async () => {
    try {
      const r = await api.get('/shopping');
      setItems(r.data);
    } catch {}
  };

  useEffect(() => { load(); }, []);

  const addItem = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    await api.post('/shopping', { name: newName, category: newCat, quantity: newQty || null });
    setNewName('');
    setNewQty('');
    load();
  };

  const toggle = async (id) => {
    await api.put(`/shopping/${id}/toggle`);
    load();
  };

  const deleteItem = async (id) => {
    await api.delete(`/shopping/${id}`);
    load();
  };

  const clearChecked = async () => {
    await api.delete('/shopping/clear/checked');
    load();
  };

  const grouped = CATEGORIES.map(cat => ({
    ...cat,
    items: items.filter(i => i.category === cat.value),
  })).filter(g => g.items.length > 0);

  const total = items.length;
  const checked = items.filter(i => i.checked).length;

  return (
    <div>
      <div className="page-header page-header-row">
        <div>
          <h1>Liste de courses</h1>
          <p>{checked}/{total} articles cochés</p>
        </div>
        {checked > 0 && (
          <button className="btn btn-secondary btn-sm" onClick={clearChecked}>
            Supprimer les cochés
          </button>
        )}
      </div>

      <form onSubmit={addItem} className="shopping-add">
        <input className="form-input" value={newName} onChange={e => setNewName(e.target.value)} placeholder="Ajouter un article..." required />
        <input className="form-input" value={newQty} onChange={e => setNewQty(e.target.value)} placeholder="Qté" style={{ maxWidth: 80 }} />
        <select className="form-input" value={newCat} onChange={e => setNewCat(e.target.value)} style={{ maxWidth: 160 }}>
          {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
        <button type="submit" className="btn btn-primary btn-sm">+</button>
      </form>

      {grouped.length === 0 ? (
        <div className="empty-state">
          <div className="empty-emoji">&#128722;</div>
          <p>Votre liste de courses est vide. Ajoutez des articles ou générez-les depuis vos repas !</p>
        </div>
      ) : (
        <div className="shopping-categories">
          {grouped.map(group => (
            <div key={group.value} className="card" style={{ padding: 16 }}>
              <div className="shopping-category-title">
                <span dangerouslySetInnerHTML={{ __html: group.emoji }} /> {group.label}
                <span style={{ marginLeft: 'auto', fontSize: '0.72rem', color: 'var(--text-muted)' }}>
                  {group.items.filter(i => i.checked).length}/{group.items.length}
                </span>
              </div>
              {group.items.map(item => (
                <div key={item.id} className={`shopping-item ${item.checked ? 'checked' : ''}`}>
                  <div
                    className={`task-checkbox ${item.checked ? 'checked' : ''}`}
                    onClick={() => toggle(item.id)}
                    style={{ width: 20, height: 20 }}
                  >
                    {item.checked && <span style={{ fontSize: '0.7rem' }}>&#10003;</span>}
                  </div>
                  <span className="shopping-item-name">{item.name}</span>
                  {item.quantity && <span className="shopping-item-qty">{item.quantity}</span>}
                  <button className="btn-ghost" style={{ fontSize: '0.7rem' }} onClick={() => deleteItem(item.id)}>&#10005;</button>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
